import React from 'react';
import { useIntl } from 'react-intl';

import { Button, Flex, Icons } from 'baukasten';

import { useCompanionWorkspaceContext } from '../CompanionWorkspaceContext';
import messages from './messages';

export const CompanionHeaderActions = () => {
  const { formatMessage } = useIntl();
  const { isHistoryOpen, startNewChat, toggleHistory } =
    useCompanionWorkspaceContext();

  return (
    <Flex alignItems="center">
      <Button
        variant="text"
        startIcon={Icons.Edit}
        aria-label={formatMessage(messages.newChat)}
        onClick={startNewChat}
      />
      <Button
        variant="text"
        startIcon={Icons.OpenSidebar}
        aria-label={formatMessage(
          isHistoryOpen ? messages.hideHistory : messages.showHistory
        )}
        aria-expanded={isHistoryOpen}
        onClick={toggleHistory}
      />
    </Flex>
  );
};
